import {createTextVariant} from './Text.js'

export default createTextVariant('p', 'P')
